import { ApiSlugs, BetaRegistrationDto, BetaRegistrationId, ListPagination } from '@workspace/data-types';
import { Observable } from 'rxjs';
import { ApiCaller } from '../../../api-caller.service';
import { ApiConnector } from '../../../api-connector.abstract-service';
import { QueryParamsUtils } from '../../../utils/query-params.utils';

export class BetaRegistrationsAdminConnector extends ApiConnector<
  BetaRegistrationDto,
  BetaRegistrationDto,
  BetaRegistrationId
> {
  constructor(apiCaller: ApiCaller, apiPrefix: string) {
    super(apiCaller, apiPrefix, ApiSlugs.BETA_REGISTRATIONS);
  }

  list = (pagination?: ListPagination): Observable<BetaRegistrationDto[]> =>
    this.apiCaller.getRequest<BetaRegistrationDto[]>(
      this.apiPrefix,
      `${this.slug}/all${QueryParamsUtils.buildFilterParams(pagination)}`,
    );

  count = (pagination?: ListPagination): Observable<number> =>
    this.apiCaller.getRequest<number>(
      this.apiPrefix,
      `${this.slug}/all/count${QueryParamsUtils.buildFilterParams(pagination, true)}`,
    );

  override get = (betaRegistrationId: BetaRegistrationId): Observable<BetaRegistrationDto> =>
    this.apiCaller.getRequest<BetaRegistrationDto>(this.apiPrefix, `${this.slug}/${betaRegistrationId}`);
}
